// Affiliate links (Round 3 Lane 5, R-47; alvin 10/16 "do all now" on the Money line). When a listing's source has an
// affiliate program, items.affiliate_url holds that version of its link. The detail's outbound link uses it, with the
// disclosure line next to it (components/browse/AffiliateNote.tsx). Read here for the one listing a person opens, never
// by Browse or ranking, so For you is the same with links on or off (AGENTS.md: no paid placement or influence).
import { useEffect, useState } from 'react'
import { supabase } from './api'
import { useAffiliateLinks } from './membership'
import { cleanAffiliate } from './affiliateCore'

const cache = new Map<string, string | null>()

export async function affiliateUrl(itemId: string, url: string | null): Promise<string | null> {
  if (cache.has(itemId)) return cache.get(itemId) ?? null
  // a database without the column yet (before 20261017105000) answers an error: no link, nothing else changes
  const { data, error } = await supabase.from('items').select('affiliate_url').eq('id', itemId).maybeSingle()
  const out = error ? null : cleanAffiliate((data as { affiliate_url?: unknown } | null)?.affiliate_url, url)
  if (!error) cache.set(itemId, out)
  return out
}

/** The affiliate link for this listing when the affiliate_links flag is on, else null. */
export function useAffiliateUrl(itemId: string, url: string | null): string | null {
  const on = useAffiliateLinks()
  const [v, setV] = useState<{ id: string; href: string | null } | null>(null)
  useEffect(() => {
    if (!on) return
    let live = true
    void affiliateUrl(itemId, url).then((href) => { if (live) setV({ id: itemId, href }) }).catch(() => { /* plain link */ })
    return () => { live = false }
  }, [on, itemId, url])
  return on && v?.id === itemId ? v.href : null
}
